/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { crashReporter } from './crashReporter';
import { type Middleware as ReduxMiddleware } from 'redux';
import { type LogLevels } from './logger';

type ReduxErrorLoggerAction = {
  type: string;
  errorLog?: string;
  logLevel?: LogLevels;
};

export const reduxErrorLogger: ReduxMiddleware = () => (next) => (action: unknown) => {
  const typedAction = action as ReduxErrorLoggerAction;
  const isException = typedAction.type.endsWith('ERROR') || typedAction.type.endsWith('FAILURE');

  if (isException) {
    void crashReporter(
      'redux exception',
      typedAction.type,
      typedAction.errorLog,
      typedAction.logLevel,
    );
  }

  return next(action);
};
